// removed by extract-text-webpack-plugin
module.exports = {"btn":"src-components-Button----button-module---btn---2_6ft","regular":"src-components-Button----button-module---regular---1iOt2","link":"src-components-Button----button-module---link---2_rWP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/button.module.scss
// module id = 300
// module chunks = 168707334958949